const getOpaquePrimaryOpacity = <T extends string | null | undefined>(primary: T): T => {
	if (!primary) return primary;
	return `${primary}BF` as any;
};
export default getOpaquePrimaryOpacity;
